import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";
import { cn } from "@/lib/utils";

const PALETTE = [
  "bg-rose-500",
  "bg-orange-600",
  "bg-emerald-600",
  "bg-teal-600",
  "bg-sky-600",
  "bg-blue-500",
  "bg-indigo-500",
  "bg-violet-500",
  "bg-pink-600",
  "bg-slate-500",
  "bg-cyan-600",
  "bg-fuchsia-600",
];

function colorFor(username: string): string {
  let h = 0;
  for (let i = 0; i < username.length; i++) {
    h = username.charCodeAt(i) + ((h << 5) - h);
  }
  return PALETTE[Math.abs(h) % PALETTE.length];
}

const SIZE: Record<string, { root: string; text: string }> = {
  xs: { root: "h-5 w-5",  text: "text-[9px]"  },
  sm: { root: "h-7 w-7",  text: "text-[11px]" },
  lg: { root: "h-9 w-9",  text: "text-sm"     },
};

interface UserAvatarProps {
  username: string;
  src?: string | null;
  size?: "xs" | "sm" | "lg";
  className?: string;
}

export default function UserAvatar({
  username,
  src,
  size = "sm",
  className,
}: UserAvatarProps) {
  const initial = (username?.[0] ?? "?").toUpperCase();
  const { root, text } = SIZE[size];

  return (
    <Avatar className={cn(root, "shrink-0", className)}>
      {src && <AvatarImage src={src} alt={username} />}
      <AvatarFallback className={cn("text-white font-semibold", colorFor(username), text)}>
        {initial}
      </AvatarFallback>
    </Avatar>
  );
}
